<template>
  <header-title />
  <div class="container">
    <aside-body />
    <div class="main" style="margin-top: 20px; max-height: 600px">
      <el-col :span="24" style="margin-left: 30px">
        <span style="margin-right: 10px">类别</span>
        <el-select
          v-model="value"
          @change="_changeType(value)"
          placeholder="请选择"
          size="large"
          style="width: 240px; min-height: 30px"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <!-- <el-input v-model="search" placeholder="请输入要查找的文章标题" class="input" style="
            margin: 10px 20px;
            min-width: 200px;
            max-width: 300px;
            padding: 0 10px;
          " /> -->
        <el-button
          type="warning"
          style="margin-left: 30px"
          round
          @click="_toEditorPage()"
          >新增文章</el-button
        >
      </el-col>
      <el-table
        :data="newsList"
        stripe
        style="width: 100%; margin-left: 15px"
        scrollbar-always-on
      >
        <el-table-column prop="a_title" label="文章" width="280" />
        <el-table-column prop="a_pageviews" label="浏览量" width="180" />
        <el-table-column prop="a_release_time" label="发布日期" width="230" />
        <el-table-column fixed="right" label="操作" width="230">
          <template v-slot="scope">
            <el-button
              @click="_toEditorPage(scope.row.a_id_str)"
              round
              type="success"
              >编辑</el-button
            >
            <el-button
              round
              type="danger"
              @click="_deleteContentDetail(scope.row.a_id_str)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :page-size="10"
        layout="prev, pager, next"
        :total="total"
        @change="_changePage"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import headerTitle from '@/components/headerTitle.vue'
import asideBody from '@/components/asideBody.vue'
import http from '@/util/http'
import { ElMessage } from 'element-plus'

export default {
  components: { asideBody, headerTitle },
  data() {
    return {
      search: undefined,
      total: 0,
      value: '0',
      tableData: [
        {
          id: '0',
          date: '2016-05-03',
          title: 'Tombbbbbbbbbbbbbbbbbbbbbbbbbbbbbb'
        },
        {
          id: '1',
          date: '2016-05-03',
          title: '2'
        },
        {
          id: '2',
          date: '2016-05-03',
          title: 'Tom'
        },
        {
          id: '3',
          date: '2016-05-03',
          title: 'Tom'
        },
        {
          id: '4',
          date: '2016-05-03',
          title: 'Tom'
        },
        {
          id: '5',
          date: '2016-05-03',
          title: 'Tom'
        },
        {
          id: '6',
          date: '2016-05-03',
          title: 'Tom'
        }
      ],
      options: [
        {
          value: '0',
          label: '国家最新消息'
        },
        {
          value: '1',
          label: '当地公告'
        }
      ],
      newsList: []
    }
  },
  mounted() {
    this._getContentDetail()
  },
  methods: {
    // 去编辑页
    _toEditorPage(id) {
      this.$router.push({
        path: '/editor',
        query: { id: id }
      })
    },

    // 删除文章
    _deleteContentDetail(id) {
      console.log(this.newsList)
      http.post('delArticle', { a_id: id }).then(res => {
        console.log(res)
        if (res.code == 200) {
          ElMessage.success('删除成功')
          this.$nextTick(() => {
            location.reload()
          })
        }
      })
    },
    // 获取1类文章
    _getContentDetail(e = 1) {
      http.get('article/type_01', { pageNum: e, pageSize: 10 }).then(res => {
        if (res.code == 200) {
          this.newsList = res.data.list
          this.total = res.data.total
          console.log(this.newsList)
        }
      })
    },
    // 2类
    _getContentTwoDetail(e = 1) {
      http.get('article/type_02', { pageNum: e, pageSize: 10 }).then(res => {
        if (res.code == 200) {
          this.newsList = res.data.list
          this.total = res.data.total
          // console.log(res.data.list)
        }
      })
    },
    // 切换类别
    _changeType(value) {
      if (value == 0) {
        this._getContentDetail(1)
      } else {
        this._getContentTwoDetail(1)
      }
    },
    _changePage(e) {
      console.log(e)
      if (this.value == 0) {
        this._getContentDetail(e)
      } else {
        this._getContentTwoDetail(e)
      }
    }
  }
}
</script>

<style scoped></style>
